import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { routes, type AuthStackParamList } from '../constants/routes';
import { ForgotPasswordScreen } from '../screens/auth/ForgotPasswordScreen';
import { LoginScreen } from '../screens/auth/LoginScreen';

const Stack = createNativeStackNavigator<AuthStackParamList>();

export function AuthNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen name={routes.login} component={LoginScreen} />
      <Stack.Screen
        name={routes.forgotPassword}
        component={ForgotPasswordScreen}
      />
    </Stack.Navigator>
  );
}
